import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import toast from "react-hot-toast";
import { FaSave } from "react-icons/fa";
import { updateCourseRegistrationApi } from '../../../../Api/Registration';
import { getCourseApi } from '../../../../Api/Course';
import { getCourseTypeApi } from '../../../../Api/CourseType';
import { getCourseOfferingApi } from '../../../../Api/CourseOffering';
import { addFeeApi, getFeeByTypeIdApi, updateAmountApi } from '../../../../Api/Fee';
import BatchForm from '../BatchForm';
import SideModal from '../../../general/Sidemodal';
import { formatDate } from '../../../general/FormatDateTime';

interface Props {
    url: string;
    FetchedCourseRegistration: any;
    userDetails: any;
    handleApiCallClick: Function;
    setAssignModal: React.Dispatch<React.SetStateAction<boolean>>;
}
type CourseTypeInterface = {
    id: string;
    name: string;
    parentId: string | null;
    availability: string;
    durationType: string;
    fees: number;
    other: boolean;
    timings: [{ startTime: string, endtime: string }];
};

type CourseInterface = {
    id: string;
    name: string;
    gender: number | null
};

type CourseOfferingInterface = {
    id: string;
    courseId: string;
    courseTypeId: string;
    fees: number;
    timings: [{ startTime: string, endtime: string }];
};
type CourseRegistration = {
    id: string;
    courseOfferingId: string;
    courseName: string | null;
    courseType: string | null;
    courseNameId: string | null;
    courseTypeId: string | null;
    userId: string;
    duration: string;
    customDuration: string | null;
    timeZone: string;
    timeRange: string;
    status: string;
    fee: number;
    paidOn?: string | null;
    paidBy?: string | null;
    updatedBy: string;
    updatedOn: string;
}

export function CourseDetails({ url, FetchedCourseRegistration, userDetails, handleApiCallClick, setAssignModal }: Props) {
    const [registration, setRegistration] = useState<CourseRegistration>({
        id: "",
        courseOfferingId: "",
        courseName: "",
        courseType: "",
        courseNameId: "",
        courseTypeId: "",
        userId: "",
        duration: "",
        customDuration: null,
        timeZone: "",
        timeRange: "",
        status: "",
        fee: null,
        updatedBy: "",
        updatedOn: "",
    });
    const [courseTypes, setCourseTypes] = useState<CourseTypeInterface[]>([]);
    const [courses, setCourses] = useState<CourseInterface[]>([]);
    const [courseOfferings, setCourseOfferings] = useState<CourseOfferingInterface[]>([]);
    const [courseOfferingData, setCourseOfferingData] = useState<CourseOfferingInterface[]>([]);
    const [fetchedCourses, setFetchedCourses] = useState<any[]>([]);
    const [CourseLoader, setCoursreLoader] = useState<boolean>(false);
    const [isBatchModalOpen, setIsBatchModalOpen] = useState(false);
    const [batchData, setBatchData] = useState(null);
    var totalHours: number;

    const CDhandleApiCallClick = async () => {
        setCoursreLoader(true)
        const fetchedCourseOfferings = await getCourseOfferingApi(url) as CourseOfferingInterface[];
        setCourseOfferingData(fetchedCourseOfferings);

        const fetchedCourseTypes: any = await getCourseTypeApi(url);
        setCourseTypes(fetchedCourseTypes);

        const fetchedCoursesData = await getCourseApi(url);
        setFetchedCourses(fetchedCoursesData as any[]);

        if (FetchedCourseRegistration) {
            setRegistration(FetchedCourseRegistration);
        }

        const courseTypeIds = fetchedCourseOfferings.map((detail: any) => detail.courseTypeId);

        const filteredCourseTypes = fetchedCourseTypes.filter(
            (item: any) => courseTypeIds.includes(item.id)
        ).map((item: any) => ({
            ...item,
            timings: item.timings ? item.timings.map((timing: any) => ({
                startTime: timing.startime,
                endtime: timing.endtime
            })) : []
        }));
        setCourseOfferings(fetchedCourseOfferings);
        setCourseTypes(filteredCourseTypes);
        setCoursreLoader(false);

        //fee part 
        // if (FetchedCourseRegistration?.id && FetchedCourseRegistration?.status === "Fee Requested") {
        //     console.log("FetchedCourseRegistration ID:", FetchedCourseRegistration.id);
        //     const feeDataResponse = await getFeeByTypeIdApi(url, FetchedCourseRegistration.id);
        //     console.log("Fetched fee data:", feeDataResponse);
        //     if (feeDataResponse) {
        //         toast.success("Fee data fetched successfully.");

        //         setFeeData(feeDataResponse);
        //         setAmount(feeDataResponse.amount || null);
        //     } else {
        //         console.warn("No fee data found for the given registration ID.");
        //     }
        // } else {
        //     console.warn("FetchedCourseRegistration.id is undefined. Skipping fee API call.");
        // }
    };

    useEffect(() => {
        CDhandleApiCallClick();
    }, [FetchedCourseRegistration]);

    useEffect(() => {
        if (!fetchedCourses.length || !courseOfferingData.length || !registration?.courseType) {
            return;
        }

        const filteredCourses = fetchedCourses.filter((course: any) => {

            const isGenderMatch =
                course.gender === null || // Open to all
                (userDetails?.Gender === 1 && course.gender === 1) ||
                (userDetails?.Gender === 2 && course.gender === 2);

            const isCourseOffered = courseOfferingData.some(
                (detail: any) =>
                    detail.courseId === course.id &&
                    detail.courseTypeId === registration.courseTypeId
            );

            return isGenderMatch && isCourseOffered;
        });

        setCourses(filteredCourses);
    }, [
        registration?.courseType,
        registration?.courseTypeId, // <-- add this
        fetchedCourses,
        courseOfferingData,
        userDetails
    ]);    

    const handleChange = (e) => {
        const { name, value } = e.target;
        setRegistration((prev) => ({ ...prev, [name]: value }));

        // Reset timeRange when courseTypeId or courseNameId changes
        if (name === "courseTypeId" || name === "courseNameId") {
            setRegistration((prev) => ({ ...prev, timeRange: "" }));

            // Update fees when either course or course type changes
            if (registration.courseNameId && registration.courseTypeId) {
                // First check in courseOfferings
                const selectedOffering = courseOfferings.find(
                    offering => offering.courseId === (name === "courseNameId" ? value : registration.courseNameId) &&
                        offering.courseTypeId === (name === "courseTypeId" ? value : registration.courseTypeId)
                );

                if (selectedOffering?.fees) {
                    // If found in courseOfferings, use that fee
                    setRegistration((prev) => ({ ...prev, fee: selectedOffering.fees }));
                } else {
                    // If not found in courseOfferings, check courseTypes
                    const selectedCourseType = courseTypes.find(
                        type => type.id === (name === "courseTypeId" ? value : registration.courseTypeId)
                    );
                    if (selectedCourseType?.fees) {
                        setRegistration((prev) => ({ ...prev, fee: selectedCourseType.fees }));
                    } else {
                        setRegistration((prev) => ({ ...prev, fee: 0 }));
                    }
                }
            }
        }
    };


    const calculateOptions = () => {
        const selectedOffering = courseOfferings.find(
            offering => offering.courseId === registration.courseNameId && offering.courseTypeId === registration.courseTypeId
        );
        const selectedCourseType = courseTypes.find(type => type.id === registration.courseTypeId);
        const isFixed = selectedCourseType?.availability === "Fixed";

        // Ensure timings are available
        const availability = selectedOffering?.timings?.length > 0
            ? selectedOffering.timings
            : selectedCourseType?.timings;

        const options = [];

        if (availability && Array.isArray(availability)) {
            availability.forEach((timeslot) => {
                // Ensure timeslot has valid startTime and endtime
                if (!timeslot.startTime || !timeslot.endtime) {
                    console.error("Invalid timeslot:", timeslot);
                    return;
                }

                let start, end, totalHours;

                if (timeslot.startTime === "00:00:00" && timeslot.endtime === "23:59:00") {
                    start = 0;
                    end = 24;
                    totalHours = 24;
                } else {
                    // Safely split startTime and endtime
                    const startParts = timeslot.startTime.split(':');
                    const endParts = timeslot.endtime.split(':');

                    if (startParts.length < 2 || endParts.length < 2) {
                        console.warn("Invalid time format:", timeslot);
                        return;
                    }

                    start = parseInt(startParts[0], 10) + parseInt(startParts[1], 10) / 60;
                    end = parseInt(endParts[0], 10) + parseInt(endParts[1], 10) / 60;

                    totalHours = end - start;

                    if (isFixed) {
                        const startHour = startParts[0].padStart(2, '0');
                        const startMinute = startParts[1].padStart(2, '0');
                        const endHour = endParts[0].padStart(2, '0');
                        const endMinute = endParts[1].padStart(2, '0');
                        const timeRangeValue = `${startHour}:${startMinute}-${endHour}:${endMinute}`;

                        options.push(
                            <option key={timeRangeValue} value={timeRangeValue}>
                                {timeRangeValue}
                            </option>
                        );
                        return options;
                    }
                }

                const durationInHours = parseFloat(registration.duration === "custom" ? registration.customDuration : registration.duration);

                for (let i = 0; i <= totalHours - durationInHours; i += 0.5) {
                    const startTime = start + i;
                    const endTime = startTime + durationInHours;

                    const startHour = Math.floor(startTime).toString().padStart(2, '0');
                    const startMinutes = Math.round((startTime % 1) * 60).toString().padStart(2, '0');
                    const endHour = Math.floor(endTime).toString().padStart(2, '0');
                    const endMinutes = Math.round((endTime % 1) * 60).toString().padStart(2, '0');

                    const timeRangeValue = `${startHour}:${startMinutes}-${endHour}:${endMinutes}`;

                    options.push(
                        <option key={timeRangeValue} value={timeRangeValue}>
                            {timeRangeValue}
                        </option>
                    );
                }
            });

            if (courseTypes.find(type => type.id === registration.courseTypeId)?.other === true) {
                options.push(<option key="other" value="other">Other Timings</option>);
            }
        }

        return options;
    };

    async function HandleRegEditClick(e) {
        e.preventDefault();
        setCoursreLoader(true);
        const selectedCourseOffering = courseOfferings.find(
            (detail: any) => detail.courseId === registration.courseNameId && detail.courseTypeId === registration.courseTypeId
        );
        if (!selectedCourseOffering) {
            toast.error("Could not find the course details for the selected course and type.");
            return;
        }
        try {
            const finalDuration = registration.duration === 'custom' ? registration.customDuration : registration.duration;
            await updateCourseRegistrationApi(registration.id, selectedCourseOffering.id, Number(finalDuration), registration.timeZone, registration.timeRange, registration.status, registration.fee, url);
            handleApiCallClick();
            toast.success(`Course registration updated successfully for ${userDetails.name}.`);
        } catch (error) {
            console.error("Error updating course registration:", error);
            toast.error("Failed to update course registration. Please try again.");
        }
        setCoursreLoader(true);
    }


    function handleCreateBatchClick(e) {
        e.preventDefault();
        const [startTime, endTime] = registration.timeRange.split('-');

        setBatchData({
            courseId: registration.courseNameId,
            courseTypeId: registration.courseTypeId,
            startTime: formatTime(startTime),
            endTime: formatTime(endTime),
            StudentId: registration.userId,
            RegId: registration.id,
        });

        setIsBatchModalOpen(true);
    }

       const handleAssignBatchClick = (e) => {
        e.preventDefault();
        setAssignModal(true);
    }

    function formatTime(time) {
        const [hour, minute] = time.split(':');
        const formattedHour = hour.padStart(2, '0');
        return `${formattedHour}:${minute}`;
    }

    return (
        <div className='p-5 relative  rounded-lg'>
            <h2 className="text-2xl font-semibold mb-6">
                {/* <MdOutlineSchool className="text-blue-500" /> */}
                Course Information
            </h2>
            <form
                onSubmit={HandleRegEditClick}
                className={` ${CourseLoader ? "filter blur-[1px]" : ""} `}>
                <div className="my-4 grid md:grid-cols-2 gap-4">

                    <div className="flex flex-col space-y-2 w-full">
                        <label className={`block text-sm font-medium text-black dark:text-gray-200 mb-2 `}>Course Type</label>
                        <select
                            name="courseTypeId"
                            value={registration?.courseTypeId || ""}
                            onChange={handleChange}
                            className="w-full border border-gray-300 rounded-lg px-3 py-2 focus:outline-none focus:ring-2 focus:ring-blue-500 disabled:bg-gray-100 disabled:text-gray-500"
                            required
                            disabled={registration.status === "Ready for batch" || registration.status === "Assigned to batch"}
                        >
                            <option value="">Select Course Type</option>
                            {courseTypes.map((type) => (
                                <option key={type.id} value={type.id}>
                                    {type.name}
                                </option>
                            ))}
                        </select>
                    </div>

                    <div className="flex flex-col space-y-2 w-full">
                        <label className={`block text-sm font-medium text-black dark:text-gray-200 mb-2`}>Course</label>
                        <select
                            name="courseNameId"
                            value={registration?.courseNameId || ""}
                            onChange={handleChange}
                            className="w-full border border-gray-300 rounded-lg px-3 py-2 focus:outline-none focus:ring-2 focus:ring-blue-500 disabled:bg-gray-100 disabled:text-gray-500"
                            required
                            disabled={registration.status === "Ready for batch" || registration.status === "Assigned to batch"}
                        >
                            <option value="">Select Course</option>
                            {courses.map((course) => (
                                <option key={course.id} value={course.id}>
                                    {course.name}
                                </option>
                            ))}
                        </select>
                    </div>

                    <div className="flex flex-col space-y-2 w-full">
                        <label className={`block text-sm font-medium text-black dark:text-gray-200 mb-2 `}>
                            Duration (in minutes)
                        </label>
                        <select
                            required
                            id="duration"
                            name='duration'
                            value={registration.duration}
                            onChange={(e) => {
                                handleChange(e);
                            }}
                            className="w-full border border-gray-300 rounded-lg px-3 py-2 focus:outline-none focus:ring-2 focus:ring-blue-500 disabled:bg-gray-100 disabled:text-gray-500"
                            disabled={registration.status === "Ready for batch" || registration.status === "Assigned to batch"}
                        >
                            {registration.courseTypeId && (() => {
                                const selectedOffering = courseOfferings.find(offering => offering.courseId === registration.courseNameId && offering.courseTypeId === registration.courseTypeId);
                                const timings = selectedOffering?.timings && selectedOffering.timings.length > 0 ? selectedOffering.timings : courseTypes.find(type => type.id === registration.courseTypeId)?.timings;
                                if (timings && timings[0]?.startTime !== "00:00:00" && timings[0]?.endtime !== "23:59:00") {
                                    const maxTiming = timings.reduce(
                                        (max: any, current: any) => {
                                            const [maxStart, maxEnd] = [max.startTime, max.endtime].map((time: string) => {
                                                if (!time) return 0;
                                                const [hours, minutes] = time.split(':').map(Number);
                                                return hours + minutes / 60;
                                            });
                                            const [currentStart, currentEnd] = [current.startTime, current.endtime].map((time: string) => {
                                                if (!time) return 0;
                                                const [hours, minutes] = time.split(':').map(Number);
                                                return hours + minutes / 60;
                                            });
                                            const maxDuration = maxEnd - maxStart;
                                            const currentDuration = currentEnd - currentStart;
                                            return currentDuration > maxDuration ? current : max;
                                        }, timings[0]);

                                    const [start, end] = [maxTiming.startTime, maxTiming.endtime].map((time: string) => {
                                        if (!time) return 0;
                                        const [hours, minutes] = time.split(':').map(Number);
                                        return hours + minutes / 60; // Convert minutes to fractional hours
                                    });
                                    totalHours = end - start;
                                    const isFixed = courseTypes.find(type => type.id === registration.courseTypeId)?.availability === "Fixed";
                                    const options = [];

                                    if (isFixed) {
                                        const fixedMinutes = totalHours * 60;
                                        // ✅ Set the correct duration in state if not already set
                                        if (registration.duration !== (fixedMinutes / 60).toString()) {
                                            setRegistration((prev) => ({
                                                ...prev,
                                                duration: (fixedMinutes / 60).toString(),
                                                customDuration: null
                                            }));
                                        }

                                        options.push(
                                            <option key={fixedMinutes} value={(fixedMinutes / 60)}>
                                                {fixedMinutes} minutes ({(fixedMinutes / 60).toFixed(1)} hour{fixedMinutes > 60 ? "s" : ""})
                                            </option>
                                        );
                                        return options;
                                    } else {
                                        for (let i = 1; i <= Math.min(totalHours * 2, 6); i++) {
                                            const minutes = i * 30;
                                            if (minutes > totalHours * 60) {
                                                break;
                                            }
                                            options.push(<option key={minutes} value={(minutes / 60)}>{minutes} minutes ({(minutes / 60).toFixed(1)} hour{minutes > 60 ? 's' : ''})</option>);
                                        }
                                    }

                                    if (totalHours > 3) {
                                        options.push(<option key="custom" value="custom">Custom</option>);
                                    }
                                    return options;
                                } else {
                                    return (
                                        <>
                                            <option value="0.5">30 minutes</option>
                                            <option value="1">60 minutes (1 hour)</option>
                                            <option value="1.5">90 minutes (1.5 hours)</option>
                                            <option value="2">120 minutes (2 hours)</option>
                                            <option value="2.5">150 minutes (2.5 hours)</option>
                                            <option value="3">180 minutes (3 hours)</option>
                                            <option value="custom">Custom</option>
                                        </>
                                    );
                                }
                            })()}
                        </select>
                        {registration.duration === 'custom' && (
                            <div className="mb-4">
                                <label className={`block text-sm font-medium text-black dark:text-gray-200 mb-2 `}>
                                    Custom Duration (in minutes) {registration.customDuration}
                                </label>
                                <input
                                    type="number"
                                    name="customDuration"
                                    value={registration.customDuration}
                                    onChange={handleChange}
                                    className="w-full border border-gray-300 rounded-lg px-3 py-2 focus:outline-none focus:ring-2 focus:ring-blue-500 disabled:bg-gray-100 disabled:text-gray-500"
                                    placeholder="Enter duration (multiple of 30)"
                                    min="3.5"
                                    max={totalHours}
                                    step="0.5"
                                    required={registration.duration === 'custom'}
                                    disabled={registration.status === "Ready for batch" || registration.status === "Assigned to batch"}
                                />
                                <p className="text-sm text-gray-600 mt-1">Duration will be rounded to the nearest 30 minutes</p>
                            </div>
                        )}
                    </div>
                   <div className="flex flex-col space-y-2 w-full">
                        <label className={`block text-sm font-medium text-black dark:text-gray-200 mb-2 `}>
                            Preferred Timings
                        </label>
                        <select
                            required
                            name="timeRange"
                            value={registration.timeRange}
                            onChange={(e) => handleChange(e)}
                            className="w-full border border-gray-300 rounded-lg px-3 py-2 focus:outline-none focus:ring-2 focus:ring-blue-500 disabled:bg-gray-100 disabled:text-gray-500"
                            disabled={registration.status === "Ready for batch" || registration.status === "Assigned to batch"}
                        >
                            <option value="">Select Preferred Timing</option>
                            {calculateOptions()}
                        </select>
                    </div>
                    <div className="flex flex-col space-y-2 w-full">
                        <label className={`block text-sm font-medium text-black dark:text-gray-200 mb-2 `}>
                            Status
                        </label>
                        <select
                            required
                            name="status"
                            value={registration.status}
                            onChange={(e) => handleChange(e)}
                            className="w-full border border-gray-300 rounded-lg px-3 py-2 focus:outline-none focus:ring-2 focus:ring-blue-500 disabled:bg-gray-100 disabled:text-gray-500"
                            disabled={registration.status === "Ready for batch" || registration.status === "Assigned to batch"}
                        >
                            {registration.status === "New" && <option value="New">New</option>}
                            {registration.status !== "Ready for batch" &&
                                registration.status !== "Assigned to batch" &&
                                <option value="Fee Requested">Fee Requested</option>}
                            <option value="Ready for batch">Ready for batch</option>
                            <option value="Assigned to batch">Assigned to batch</option>
                            <option value="In Progress">In Progress</option>
                            <option value="Not Interested">Not Interested</option>
                            <option value="On Hold">On Hold</option>
                        </select>
                    </div>

                    <div className="flex flex-col space-y-2 w-full">
                        <label className={`block text-sm font-medium text-black dark:text-gray-200 mb-2`}>Fee amount</label>
                        <input
                            type="number"
                            name='fee'
                            value={registration.fee}
                            onChange={(e) => handleChange(e)}
                            className="w-full border border-gray-300 rounded-lg px-3 py-2 focus:outline-none focus:ring-2 focus:ring-blue-500 disabled:bg-gray-100 disabled:text-gray-500"
                            placeholder="Fee amount"
                            disabled={registration.status === "Ready for batch" || registration.status === "Assigned to batch"}
                        />
                    </div>

                    {registration.paidOn && (
                        <div className="flex flex-col space-y-2 w-full">
                            <label className={`block text-sm font-medium text-black dark:text-gray-200 mb-2`}>Paid On</label>
                            <p className="w-full border border-gray-300 rounded-lg px-3 py-2 bg-gray-100 text-gray-500">{formatDate(registration.paidOn) || 'Not available'}</p>
                        </div>
                    )}
                    {registration.paidBy && registration.paidOn && (
                        <div className="flex flex-col space-y-2 w-full">
                            <label className={`block text-sm font-medium text-black dark:text-gray-200 mb-2`}>Paid By</label>
                            <p className="w-full border border-gray-300 rounded-lg px-3 py-2 bg-gray-100 text-gray-500">{registration.paidBy || 'Not available'}</p>
                        </div>
                    )}
                </div>

                <div className="flex flex-wrap items-center justify-start gap-2">
                    {registration.status !== "Ready for batch" && registration.status !== "Assigned to batch" && (
                        <button
                            type="submit"
                            className="flex items-center justify-center w-fit px-4 py-2 mt-3 font-medium tracking-wide text-white capitalize transition-colors duration-300 transform bg-blue-600 rounded-lg hover:bg-blue-500 focus:outline-none focus:ring focus:ring-blue-300 focus:ring-opacity-80"
                        >
                            <FaSave className="mr-2" /> save course
                        </button>
                    )}

                    {registration.status === "Ready for batch" && (
                        <div className="flex items-center justify-start gap-2">
                            <button
                                type="button"
                                className="flex items-center justify-center w-fit px-4 py-2 mt-3 font-medium  tracking-wide text-white capitalize transition-colors duration-300 transform bg-blue-600 rounded-lg hover:bg-blue-500 focus:outline-none focus:ring focus:ring-blue-300 focus:ring-opacity-80"
                                onClick={(e) => handleCreateBatchClick(e)}
                            >
                                Create Batch
                            </button>

                            <button
                                type="button"
                                className="flex items-center justify-center w-fit px-4 py-2 mt-3 font-medium tracking-wide text-white capitalize transition-colors duration-300 transform bg-blue-600 rounded-lg hover:bg-blue-500 focus:outline-none focus:ring focus:ring-blue-300 focus:ring-opacity-80"
                                onClick={handleAssignBatchClick}
                            >
                                Assign Batch
                            </button>
                        </div>
                    )}
                </div>

            </form>

            {CourseLoader && (
                <div className="absolute inset-0 flex items-center justify-center bg-white bg-opacity-75 z-50">
                    <div className="w-12 h-12 border-4 border-t-blue-500 border-gray-300 rounded-full animate-spin"></div>
                </div>
            )}
            <SideModal isOpen={isBatchModalOpen} onClose={() => setIsBatchModalOpen(false)}>
                <BatchForm
                    batchData={batchData}
                    onClose={() => setIsBatchModalOpen(false)}
                    url={url} />
            </SideModal>

        </div>

    );
}